import { Link as t } from "./index3.js";
function s(a, e) {
  if (!e.showLegalDocuments)
    return new t(!1, "");
  const n = e["documentCenterPath_" + a] ?? r(a);
  return new t(!0, n);
}
function r(a) {
  let e = "/contracts/";
  switch (a) {
    case "CA":
      e += "canada";
      break;
    case "GB":
      e += "uk";
      break;
    case "AU":
      e += "australia";
      break;
    case "DE":
      e += "";
      break;
    default:
      e += "usa";
      break;
  }
  return e.endsWith("/") ? e : e + "/";
}
export {
  s as createLegalDocumentsLink
};
//# sourceMappingURL=index7.js.map
